var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { useDefaultSliceLayout } from '../hooks/use-default-slice-layout';
import { useSliceLayouts } from '../context/slice-layouts-context';
import { EntityProvider } from '../context/entity-context';
import { keys } from 'lodash';
var cls = classNames('slices-renderer');
export var SlicesRendererDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
// -------- Components -------->
var My = {
  NAME: 'SlicesRenderer'
};
export var SlicesRenderer = function (props) {
  var componentProps = useComponentProps(My.NAME, SlicesRendererDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    items = componentProps.items;
  var DefaultLayout = useDefaultSliceLayout();
  var sliceLayouts = useSliceLayouts();
  return React.createElement(React.Fragment, null, items.filter(function (slice) {
    return !slice.disabled;
  }).map(function (slice, index) {
    var layout = slice.layout;
    var SliceComponent = layout ? sliceLayouts[layout.component] || DefaultLayout : DefaultLayout;
    if (layout && !sliceLayouts[layout.component]) {
      console.warn("Slice Layout Component \"".concat(layout.component, "\" referenced by Slice \"").concat(slice.name, "\" is not available in the provided set of templates (").concat(keys(sliceLayouts).join(", "), "). Using default layout instead."));
    }
    return SliceComponent && React.createElement(EntityProvider, {
      key: "".concat(slice.id, "-").concat(index),
      value: slice
    }, React.createElement("div", {
      key: "".concat(slice.id, "-").concat(index, "-slice"),
      id: slice.slug
    }, React.createElement(SliceComponent, {
      entity: slice
    })));
  }));
};
SlicesRenderer.cls = cls;
var templateObject_1;